module.exports = __webpack_public_path__ + "static/media/s_v9_t10_2.72b7b7ea.mp3";